import { K as LibK } from '@symbolic/rn-lib/dist/styles/index';

var K = {
  ...LibK,
  minPrecision: 1 / 16
};

export default K;
